export default __webpack_public_path__ + "static/media/social_kakao.52e9a48b.svg";